import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { icons } from '@assets/icons';

export const LoginBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  width: 100vw;
  height: calc(100vh - 80px);
  & input:focus[data-invalid$='capslock' i],
  input[data-invalid$='capslock' i] {
    border-color: #fbbb3a !important;
    & ~ div[data-type='validate'] {
      &::after {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        font-size: 13px;
        color: #fbbb3a;
        text-align: left;
        content: 'Caps Lock ON.';
      }
    }
  }
`;

export const LoginField = styled.fieldset`
  @keyframs rotate {
    from {
      transform: rotate(-1turn);
    }
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 800px;
  min-height: 509px;
  padding: 80px 0 0 0;
  border-width: 0;
  border-top: 5px solid #7fe200;
  background: #ffffff;
  & > div {
    &[data-name='ID' i],
    &[data-name='Password' i] {
      margin: 15px auto;
      width: 320px;
    }
  }
  & > button {
    margin: 15px auto 10px;
    &[data-loading='true']:disabled {
      color: #ffffff;
      &:before {
        padding: 10px;
        content: url(${icons.progress});
        animation: 3s linear infinite;
        width: 24px;
        height: 24px;
      }
    }
  }
  .go_license {
    margin-top: 100px;
    font-size: 12px;
    color: #7e7e7e;
  }
`;

export const LoginFieldTitle = styled.h1`
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  height: 40px;
  color: #00bf00;
  margin: 10px auto;
`;

export const LockIcon = styled.div`
  box-sizing: border-box;
  border: 2px solid #00bf00;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:before {
    content: '';
    box-sizing: border-box;
    height: 8.07px;
    width: 10.04px;
    border: 2.5px solid #00bf00;
    border-bottom-width: 0;
    border-top-left-radius: 100%;
    border-top-right-radius: 100%;
    margin-bottom: 1.24px;
  }
  &:after {
    content: '';
    box-sizing: border-box;
    height: 9.86px;
    width: 14.4px;
    border: 2.5px solid #00bf00;
    background: #00bf00;
  }
`;

export const IdValidationStyle = css`
  input[data-invalid='none' i]:invalid {
    border: 1px solid #ff4c4c !important;
    position: relative;
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        content: 'Please enter the ID.';
        color: #ff4c4c;
        font-size: 13px;
        position: absolute;
        top: 100%;
        height: 30px;
      }
    }
  }
  input[data-invalid='short' i] {
    border: 1px solid #ff4c4c !important;
    position: relative;
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        content: 'Use 3 or more characters.';
        color: #ff4c4c;
        font-size: 13px;
        position: absolute;
        top: 100%;
        height: 30px;
      }
    }
  }

  input[data-invalid='invalid' i] {
    border: 1px solid #ff4c4c !important;
    position: relative;
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        content: 'Please enter the Valid ID.';
        color: #ff4c4c;
        font-size: 13px;
        position: absolute;
        top: 100%;
        height: 30px;
      }
    }
  }

  input[data-invalid='regex-invalid' i] {
    border: 1px solid #ff4c4c !important;
    position: relative;
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        content: 'Use only English and numbers.';
        color: #ff4c4c;
        font-size: 13px;
        position: absolute;
        top: 100%;
        height: 30px;
      }
    }
  }

  input[data-invalid='capslock' i] {
    border: 1px solid #ff4c4c !important;
    position: relative;
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        content: 'Capslock is on.';
        color: #ff4c4c;
        font-size: 13px;
        position: absolute;
        top: 100%;
        height: 30px;
      }
    }
  }
`;
export const PwValidationStyle = css`
  input[data-invalid='not match'],
  input[data-invalid='short'],
  input[data-invalid='regrex'],
  input[data-invalid='sameidpwd'],
  input[data-invalid$='true' i]:invalid {
    border-color: #ff4c4c !important;
    position: relative;
    & ~ span {
      color: #ff4c4c;
    }
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        color: #ff4c4c;
        font-size: 13px;
        text-align: left;
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
      }
    }
  }

  &.width-limit {
    width: 100%;

    div {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      input,
      input[data-invalid='not match'],
      input[data-invalid='short'],
      input[data-invalid='regrex'],
      input[data-invalid='sameidpwd'],
      input[data-invalid$='true' i]:invalid {
        position:absolute;
        width: 100%;
        & ~ div[data-type='validate'] {
          flex: 1;
          margin-left: 10px;
          &::after {
            top: 42px;
            font-size:12px;
          }
        }
      }
    }
  }

  input[data-invalid$='true' i]:invalid {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Please enter the Password.';
      }
    }
  }
  input[data-invalid='not match'] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Enter the same password.';
      }
    }
  }
  input[data-invalid='short'] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Use at least 10 characters. (letters, numbers and symbols other than \<\>\\'\&\\"\(\)\#)';
      }
    }
  }
  input[data-invalid='regrex'] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Use at least 10 characters. (letters, numbers and symbols other than \<\>\\'\&\\"\(\)\#)';
      }
    }
  }
  input[data-invalid='sameidpwd'] {
    & ~ div[data-type='validate'] {
      &::after {
        color: #ff4c4c;
        content: 'It cannot be the same as the ID';
      }
    }
  }
`;

export const EmailValidationStyle = css`
  input[data-invalid$='true' i]:invalid {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Please enter a valid Email.';
      }
    }
  }

  input[data-invalid$='validate-mix' i] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Please enter a valid Email.';
      }
    }
  }
`;
